// @flow

import type { ThemeSetupState, ThemeSetupAction } from 'stores/flow-type/theme-setup.type';

import {
  GET_THEMES_REQUEST,
  GET_THEMES_SUCCESS,
  GET_THEMES_FAILURE,
  GET_ALL_THEMES_REQUEST,
  GET_ALL_THEMES_SUCCESS,
  GET_ALL_THEMES_FAILURE,
  CHECK_THEME_REQUEST,
  CHECK_THEME_SUCCESS,
  CHECK_THEME_FAILURE,
  SETUP_THEME_REQUEST,
  SETUP_THEME_SUCCESS,
  SETUP_THEME_FAILURE,
  SUBMIT_ERROR_REQUEST,
  SUBMIT_ERROR_SUCCESS,
  SUBMIT_ERROR_FAILURE,
  INTEGRATE_GEMPAGES_REQUEST,
  INTEGRATE_GEMPAGES_SUCCESS,
  INTEGRATE_GEMPAGES_FAILURE,
  RESET_THEME_SETUP
} from 'stores/flow-type/theme-setup.type';

const initialState: ThemeSetupState = {
  getThemesLoading: false,
  getAllThemesLoading: false,
  checkThemeLoading: false,
  setupThemeLoading: false,
  submitErrorLoading: false,
  integrateGemPagesLoading: false,
  getThemesSuccess: false,
  getAllThemesSuccess: false,
  checkThemeSuccess: false,
  setupThemeSuccess: false,
  submitErrorSuccess: false,
  integrateGemPagesSuccess: false,
  error: undefined,
  setupThemeError: undefined,
  themes: [],
  allThemes: [],
  isTrialTheme: false,
  inputThemeName: '',
  outputThemeName: '',
  isOS20: false,
  integrateGemPagesThemes: {}
};

const themeSetupReducers = (state: ThemeSetupState = initialState, action: ThemeSetupAction) => {
  switch (action.type) {
    case GET_THEMES_REQUEST:
      return { ...state, getThemesLoading: true, getThemesSuccess: false };
    case GET_ALL_THEMES_REQUEST:
      return { ...state, getAllThemesLoading: true, getAllThemesSuccess: false };
    case CHECK_THEME_REQUEST:
      return {
        ...state,
        checkThemeLoading: true,
        checkThemeSuccess: false,
        isTrialTheme: false,
        inputThemeName: '',
        outputThemeName: '',
        isOS20: false
      };
    case SETUP_THEME_REQUEST:
      return { ...state, setupThemeLoading: true, setupThemeSuccess: false };
    case SUBMIT_ERROR_REQUEST:
      return { ...state, submitErrorLoading: true, submitErrorSuccess: false };
    case INTEGRATE_GEMPAGES_REQUEST:
      return { ...state, integrateGemPagesLoading: true, integrateGemPagesSuccess: false };
    case GET_THEMES_SUCCESS: {
      const { data } = action.payload;
      const existedThemeLibV2 = data.findIndex(({ themeLibV2 }) => themeLibV2) !== -1;

      return {
        ...state,
        getThemesLoading: false,
        getThemesSuccess: true,
        error: undefined,
        themes: data,
        existedThemeLibV2
      };
    }
    case GET_ALL_THEMES_SUCCESS: {
      const { data = [] } = action.payload;

      return {
        ...state,
        getAllThemesLoading: false,
        getAllThemesSuccess: true,
        error: undefined,
        allThemes: data
      };
    }
    case CHECK_THEME_SUCCESS: {
      const {
        data: { isTrialTheme, inputThemeName, outputThemeName, isOS20 }
      } = action.payload;
      return {
        ...state,
        checkThemeLoading: false,
        checkThemeSuccess: true,
        isTrialTheme,
        inputThemeName,
        outputThemeName,
        isOS20,
        error: undefined
      };
    }
    case SETUP_THEME_SUCCESS: {
      return {
        ...state,
        setupThemeLoading: false,
        setupThemeSuccess: true,
        setupThemeError: undefined
      };
    }
    case SUBMIT_ERROR_SUCCESS:
      return {
        ...state,
        submitErrorLoading: false,
        submitErrorSuccess: true,
        error: undefined
      };
    case INTEGRATE_GEMPAGES_SUCCESS: {
      return {
        ...state,
        integrateGemPagesLoading: false,
        integrateGemPagesSuccess: true,
        integrateGemPagesThemes: action.payload.data,
        error: undefined
      };
    }
    case GET_THEMES_FAILURE:
      return {
        ...state,
        getThemesLoading: false,
        getThemesSuccess: false,
        error: action.payload
      };
    case GET_ALL_THEMES_FAILURE:
      return {
        ...state,
        getAllThemesLoading: false,
        getAllThemesSuccess: false,
        error: action.payload
      };
    case CHECK_THEME_FAILURE:
      return {
        ...state,
        checkThemeLoading: false,
        checkThemeSuccess: false,
        isOS20: false,
        error: action.payload
      };
    case SETUP_THEME_FAILURE:
      return {
        ...state,
        setupThemeLoading: false,
        setupThemeSuccess: false,
        setupThemeError: action.payload
      };
    case SUBMIT_ERROR_FAILURE:
      return {
        ...state,
        submitErrorLoading: false,
        submitErrorSuccess: false,
        error: action.payload
      };
    case INTEGRATE_GEMPAGES_FAILURE:
      return {
        ...state,
        integrateGemPagesLoading: false,
        integrateGemPagesSuccess: false,
        error: action.payload
      };

    case RESET_THEME_SETUP:
      return initialState;
    default:
      return state;
  }
};
export default themeSetupReducers;
